import Vue from 'vue'
import Router from 'vue-router'
import menuModule from 'vuex-store/modules/menu'
import jwt from 'jsonwebtoken'
Vue.use(Router)

let router = new Router({
  mode: 'history', // Demo is living in GitHub.io, so required!
  linkActiveClass: 'is-active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      name: 'Home',
      path: '/',
      component: require('../views/Home')
    },
    {
      name: 'Settings',
      path: '/setting',
      component: require('../views/components/Setting')
    },
    {
      path: '/auth/personal-token',
      meta: {
        auth: {
          roles: ['user'],
          redirect: {name: 'Home'} // ,
//          forbiddenRedirect: {path: '/'}
        }
      },
      component: require('../views/auth/Personal-Token')
    },
    ...generateRoutesFromMenu(menuModule.state.items),
    {
      path: '*',
      redirect: '/'
    }
  ]
})

// Menu should have 2 levels.
function generateRoutesFromMenu (menu = [], routes = []) {
  for (let i = 0, l = menu.length; i < l; i++) {
    let item = menu[i]
    if (item.path) {
      routes.push(item)
    }
    if (!item.component) {
      generateRoutesFromMenu(item.children, routes)
    }
  }
  return routes
}

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => { return record.meta.group !== undefined })) {
    let routeGroups = to.meta.group
    let groups = null
    try {
      var decodedToken = jwt.decode(window.localStorage['access_token']) // must be same as in app.js
      groups = decodedToken['cognito:groups']
    } catch (e) {}

    if (groups) {
      let hasPermission = false
      if (routeGroups) {
        for (let routeGroup of routeGroups) {
          if (groups.includes(routeGroup)) {
            hasPermission = true
            break
          }
        }
      } else {
        hasPermission = true
      }
      if (hasPermission) {
        next()
      } else {
        console.log('No permission for this group')
        next({path: '/'})
      }
    } else {
      console.log('Group (cognito-groups) does not exist. No permissions')
      next({path: '/'})
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./client/router/index.js